import * as z from "zod";

export const deleteReviewForm = {
  name: "deleteReviewForm" as const,
  input: z.object({ formId: z.string() }),
  output: z.null(),
};
